import { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { FormikInput } from "../../../../components/formik-components";

import { useNavigate } from "react-router-dom";
import { Button } from "../../../../components/ui/button";
import { respEnum } from "../../../../constants/appConstant";
import Common from "../../../../helper/common";
import { Icon } from "@iconify/react";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../components/ui/dialog";

const FormikInitialValues = {
  name: null,
};

const formikValidation = yup.object({
  name: yup.string().required("Name is required"),
});

const AddRankingCategory = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  useEffect(() => {
    if (id) {
      getDataInfo();
    }
  }, [id]);

  const onSubmitData = async (d, action) => {
    let data = {
      ...d,
      id,
    };

    let response = await Common.ApiService.getInstance().request(
      "AddUpdateRankingCategory",
      data,
      "POST"
    );

    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      onClose(response.data);
      setOpen(false);
      if (!onClose) {
        navigate("/app/RankingCategories", { replace: true });
      }
    }
  };

  const getDataInfo = async () => {
    debugger;
    let response = await Common.ApiService.getInstance().request(
      `GetRankingCategory?id=${id}`
    );
    if (response.status === respEnum.Success && response.data.length > 0) {
      const item = response.data[0];

      formikRef.current.setValues({
        ...item,
      });
    }
  };

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
            Add
          </Button>
        </DialogTrigger>
        <DialogContent ref={dialogRef}>
          <DialogHeader>
            <DialogTitle className="text-base font-medium ">
              {!id ? "Add" : "Update"} Ranking Category
            </DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500  space-y-2 max-h-[450px] overflow-y-auto pr-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                  <div className="col-span-1">
                    <div className="md:grid md:grid-cols-1  gap-6 mt-6 space-y-6 md:space-y-0">
                      <div className="flex flex-col gap-1">
                        <FormikInput
                          formikProps={formikProps}
                          name={"name"}
                          label={"Name"}
                          placeholder={"Category Name"}
                          maxLength="50"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </div>
          <DialogFooter className="mt-8 gap-2">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Close
              </Button>
            </DialogClose>

            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Saving..."
                  : !id
                  ? "Add"
                  : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddRankingCategory;
